import { PostHogProvider as BasePostHogProvider } from '@posthog/react';
import posthog from 'posthog-js';

const POSTHOG_SENSITIVE_MASK_ID = 'sensitive';
const isPostHogEnabled = import.meta.env.VITE_POSTHOG_ENABLED === 'true';
const canInitializePostHog = isPostHogEnabled && typeof window !== 'undefined';

function getPosthogApiHost() {
  return new URL('/ingest', window.location.origin).toString();
}

if (canInitializePostHog) {
  posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
    api_host: getPosthogApiHost(),
    ui_host: 'https://us.posthog.com',
    defaults: '2026-05-30',
    debug: import.meta.env.MODE === 'development',
    person_profiles: 'identified_only',
    capture_exceptions: true,
    capture_heatmaps: true,
    session_recording: {
      maskTextSelector: '#sensitive',
    },
  });
}

function PosthogProvider({ children }: { children: React.ReactNode }) {
  if (!canInitializePostHog) {
    return <>{children}</>;
  }

  return <BasePostHogProvider client={posthog}>{children}</BasePostHogProvider>;
}

export { posthog, POSTHOG_SENSITIVE_MASK_ID, PosthogProvider, isPostHogEnabled };
